import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class ConferenceRepository {

  /**
   * @param {Object} params
   *
   * @returns {Promise}
   */
  async searchConferences(params) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/news/conferences`,
      params
    );

    return response.data;
  }
}

const conference_repository = new ConferenceRepository();

export {
  conference_repository,
};
